import React, { FC, useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import * as classes from './TestimonialsCarousel.module.scss';

SwiperCore.use([Navigation, Autoplay]);

interface Props {
  items: Array<string>;
  slideChangeAction: (index: number) => void;
}

const TestimonialsCarousel: FC<Props> = ({ items, slideChangeAction }) => {
  const carouselItems = useMemo(() => {
    return items.map((item, index) => {
      return (
        <SwiperSlide key={index}>
          <div className={classes.slide} dangerouslySetInnerHTML={{ __html: item }} />
        </SwiperSlide>
      );
    }, []);
  }, [items]);

  return (
    <div className={'swiper-default-template'}>
      <Swiper slidesPerView={1} spaceBetween={0} navigation={true} onRealIndexChange={index => slideChangeAction(index.realIndex)} autoplay>
        {carouselItems}
      </Swiper>
    </div>
  );
};

export default TestimonialsCarousel;
